import { MailIcon } from "@heroicons/react/outline";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { AiOutlineQrcode } from 'react-icons/ai';
import CloseIcon from '../../../assets/Close.svg';
import Mail from '../../../assets/Mail.svg';
import { AlertTexts } from "../../../language/Texts";
import { ComponentType } from "../../../models/componentType.enum";
import { Utils } from "../../../utils/Utils";
import './SuccessModal.scss';
import { useEffect } from "react";



interface ModalProps {
    show: boolean
    type: ComponentType
}



function SuccessModal({ show, type }: ModalProps) {
    useEffect(() => {
        if (show && type === ComponentType.GEMUE_EXTERNAL) {
            document.body.classList.add('gemue-modal-active');
        } else {
            document.body.classList.remove('gemue-modal-active');
        }
        return () => {
            document.body.classList.remove('gemue-modal-active');
        };
    }, [show, type]);

    const handleHide = () => {
        const { redirectUrl } = Utils.getRedirectInfos()
        window.location.href = redirectUrl;
    }

    const getModalText = () => {
        if (Utils.isBatteryPass()) {
            return AlertTexts.modalTextBatteryPass
        }
        return AlertTexts.modalText
    }

    const gemueModal = () => {
        return (
            <Modal.Body className="gemue_modal_body">
                <div className="close_icon_wrapper" onClick={handleHide}>
                    <img className="close_icon" src={CloseIcon} alt="" />
                </div>
                <div className="gemue_mail_icon_wrapper" >
                    <img src={Mail} className="gemue_mail_icon" alt="" />
                </div>
                <div className="gemue_modal_text">
                    {AlertTexts.modalTextGemue}
                </div>
                <div className="gemue_modal_sub_text">
                    {AlertTexts.modalSubTextGemue}
                </div>
                <div className="gemue_modal_button_wrapper">
                    <Button
                        className="gemue_modal_button"
                        onClick={handleHide}>
                        {AlertTexts.createAgain}
                    </Button>
                </div>
            </Modal.Body>
        )
    }

    const otherModal = () => {
        return (
            <Modal.Body className="modal_body">
                <div className="modal_text">
                    {getModalText()}
                </div>
                <div className="mail_icon_wrapper">
                    <AiOutlineQrcode className="qr_code_icon" />
                    <MailIcon className='mail_icon' />
                </div>
                <Button
                    className="modal_button"
                    onClick={handleHide}>
                    {AlertTexts.createAgain}
                </Button>
            </Modal.Body>
        )
    }

    return (
        <Modal
            show={show}
            onHide={handleHide}
            centered
            className="modal_wrapper"
            backdrop="static" // Disable backdrop click
            keyboard={false}  // Disable keyboard interactions
        >
            {type === ComponentType.GEMUE_EXTERNAL ? gemueModal() : otherModal()}
        </Modal>
    );
}

export default SuccessModal
